import { type Profile, Role } from '@gm-commercial/profile-model';

import { ADMIN_ROLES } from '~/common/constants/common.constant';

/**
 * Returns the organization ID from an acting profile, if present.
 */
export const getActingOrgId = (
  actingProfile: Profile | undefined
): string | undefined =>
  actingProfile?.organization?.id ??
  actingProfile?.permissionsContextIds?.organizationsId;

/**
 * Whether redux-persist has a valid acting-org context for the current admin user.
 */
export const hasPersistedActingOrgContext = (
  profile: Profile | undefined,
  actingProfile: Profile | undefined
): boolean => {
  if (!profile?.id || !profile.role || !ADMIN_ROLES.includes(profile.role)) {
    return false;
  }

  if (actingProfile?.id !== profile.id) {
    return false;
  }

  const actingOrgId = getActingOrgId(actingProfile);
  return !!actingOrgId && actingProfile?.role === Role.ORG_MANAGER;
};
